import React from "react";
import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

/* stylelint-disable property-no-vendor-prefix */
const JunoButton = styled.button`
  display: inline-flex;
  align-items: center;

  border-radius: 5px;
  border-width: 0 0 2px 0;
  border-style: solid;
  padding: 4px 16px;

  font-family: var(--juno-font-family-secondary);
  line-height: 1.75;
  font-weight: var(--juno-font-weight-bold);

  font-size: var(--juno-font-size-h3-sm);
  letter-spacing: 0.02em;

  color: var(--juno-color-button-text);
  background-color: var(--juno-color-button);
  border-color: var(--juno-color-button-shadow);

  text-align: center;
  cursor: pointer;
  -webkit-appearance: none;

  &:-moz-focus-inner {
    padding: 0;
    border: 0;
  }

  &:focus-visible {
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
  }

  /* Action renders this as a react-router Link on the thanks pages, where
     the global a:link and a:visited colours would otherwise win. */
  &:link,
  &:visited {
    color: var(--juno-color-button-text);
  }

  &:hover,
  &:focus-visible {
    border-bottom: 2px solid var(--juno-color-button-shadow);
    background-color: var(--juno-color-button-hover);
  }

  &:hover {
    transition: background-color 0.3s;
  }

  &:active {
    top: 2px;
    box-shadow: 0 0 0 var(--juno-color-button);
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
      color: var(--juno-color-button-text);
      background-color: var(--juno-color-button);

      &:hover {
        background-color: var(--juno-color-button);
        cursor: default;
      }
    `}

  ${(props) =>
    props.small &&
    css`
      font-size: var(--juno-font-size-body-sm);

      ${mediaQueries.md} {
        font-size: var(--juno-font-size-body-md);
      }
    `}

  ${(props) =>
    props.large &&
    css`
      padding-left: 1em;
      padding-right: 1em;
    `}

  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `}
`;

const JunoButtonText = styled.span`
  width: 100%;
  display: inherit;
  align-items: inherit;
  justify-content: inherit;
`;

export const SecondaryButton = styled(Button)`
  color: var(--juno-color-secondary-button-text);
  background-color: var(--juno-color-secondary-button);
  border-top-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  border-color: var(--juno-color-secondary-button-shadow);

  &:hover,
  &:focus-visible {
    border-bottom: 2px solid var(--juno-color-secondary-button-shadow);
    background-color: var(--juno-color-secondary-button-hover);
  }

  &:hover {
    transition: background-color 0.3s;
  }

  &:active {
    top: 2px;
    box-shadow: 0 0 0 var(--juno-color-secondary-button);
  }
`;
/* stylelint-enable property-no-vendor-prefix */

function Button(props) {
  return (
    <JunoButton {...props}>
      <JunoButtonText>{props.children}</JunoButtonText>
    </JunoButton>
  );
}

export default Button;
